import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds.about.title',
        defaultMessage: 'About 3DS',
    },
    gotIt: {
        id: 'modal.3ds.about.got_it',
        defaultMessage: 'Got it',
    },
    description: {
        id: 'modal.3ds.about.description',
        defaultMessage:
            "<b>3D Secure is an extra security check to confirm it's really you when you pay online. We may use one of these methods:</b><br><br><b>SMS</b><br><span>A one-time code is sent to the phone number used when this card was created. Enter it on the payment page to confirm. Works without an app or internet connection.</span><br><br><b>Email</b><br><span>A one-time code is sent to the email address used when this card was created. Enter it on the payment page to confirm. Useful when your phone is unavailable.</span><br><br><b>Biometrics</b><br><span>When you have a transaction to confirm, you'll see it in the mobile app — approve with your fingerprint or face, just like unlocking your phone.</span><br><br><b>In-wallet approval</b><br><span>When you have something to approve, you'll see it in your wallet — open it on web or in the app, and tap Approve.</span><br><br><b>Security questions</b><br><span>Answer a personal question you set up beforehand (e.g. your first teacher's name). No phone needed.</span>",
    },
})
